import React from "react";
import StopClientComponent from "../../components/StopClient/StopClient.component";
import IPage from "../../interfaces/page"

const StopClientPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <StopClientComponent></StopClientComponent>;
};

export default StopClientPage;
